/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ discount_yearly_price: NonNullable<unknown> }} New_User_Yearly_Subscription_BtnInputs */

const en_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribe ${i?.discount_yearly_price}/year`)
};

const ar_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اشترك ${i?.discount_yearly_price}/سنة`)
};

const de_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnieren ${i?.discount_yearly_price}/Jahr`)
};

const es_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscríbete por ${i?.discount_yearly_price} / año`)
};

const fr_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.discount_yearly_price}/an`)
};

const it_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abbonati a ${i?.discount_yearly_price}/anno`)
};

const ja_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.discount_yearly_price}/年で購読`)
};

const ko_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.discount_yearly_price}/1년 가격으로 구독하기`)
};

const pt_br_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscreva-se por ${i?.discount_yearly_price}/ano`)
};

const ru_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подписывайтесь за ${i?.discount_yearly_price}/год`)
};

const th_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก ${i?.discount_yearly_price}/ปี`)
};

const tr_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık ${i?.discount_yearly_price}'ya abone ol`)
};

const zh_cn_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`购买 ${i?.discount_yearly_price}/年`)
};

const zh_tw_new_user_yearly_subscription_btn = /** @type {(inputs: New_User_Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`訂閱 ${i?.discount_yearly_price}/年`)
};

/**
* | output |
* | --- |
* | "Subscribe {discount_yearly_price}/year" |
*
* @param {New_User_Yearly_Subscription_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_user_yearly_subscription_btn = /** @type {((inputs: New_User_Yearly_Subscription_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_User_Yearly_Subscription_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_user_yearly_subscription_btn(inputs)
	if (locale === "ar") return ar_new_user_yearly_subscription_btn(inputs)
	if (locale === "de") return de_new_user_yearly_subscription_btn(inputs)
	if (locale === "es") return es_new_user_yearly_subscription_btn(inputs)
	if (locale === "fr") return fr_new_user_yearly_subscription_btn(inputs)
	if (locale === "it") return it_new_user_yearly_subscription_btn(inputs)
	if (locale === "ja") return ja_new_user_yearly_subscription_btn(inputs)
	if (locale === "ko") return ko_new_user_yearly_subscription_btn(inputs)
	if (locale === "pt_br") return pt_br_new_user_yearly_subscription_btn(inputs)
	if (locale === "ru") return ru_new_user_yearly_subscription_btn(inputs)
	if (locale === "th") return th_new_user_yearly_subscription_btn(inputs)
	if (locale === "tr") return tr_new_user_yearly_subscription_btn(inputs)
	if (locale === "zh_cn") return zh_cn_new_user_yearly_subscription_btn(inputs)
	return zh_tw_new_user_yearly_subscription_btn(inputs)
});